import React, { FC, ReactNode } from 'react';
import { Tooltip } from 'snacks-design-system';

interface IPIETooltipProps {
  children: ReactNode;
  toggle: ReactNode;
  isOpen?: boolean;
  position?: 'top' | 'bottom' | 'left' | 'right';
  align?: 'start' | 'center' | 'end';
  panelWidth?: string | number;
  showClose?: boolean;
  modCompact?: boolean;
  modStatic?: boolean;
  modFluid?: boolean;
  modClickAway?: boolean;
  modCustomToggle?: boolean;
  modHover?: boolean;
  onToggleClick?: () => void;
  onTooltipToggle?: () => void;
  onOpen?: () => void;
  onClose?: () => void;
  qaSelector?: string;
  aria?: any;
}

export const PIETooltip: FC<IPIETooltipProps> = (props) => {
  return <Tooltip {...props}>{props.children}</Tooltip>;
};

export default PIETooltip;
